import ProfileList from './ProfileList';

export default ProfileList;
